module.exports = __webpack_public_path__ + "static/media/128-fit-mobile.c6913a87.svg";